module.exports = __webpack_public_path__ + "img/testpaper_collection_pressed.ca05d05a.svg";